import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  FormControl,
  Form,
  Modal,
  Alert,
  InputGroup,
} from "react-bootstrap";
import {
  listarProdutos,
  CadastrarProduto,
  EditarProduto,
  DeletarProduto,
  listarProdutosPorCategoria,
} from "../../providers/ProdutosProvider";
import { api_url_produtos_image } from "../../providers/api";
import UploadImage from "../../components/UploadImage";
import ImageList from "../../components/ImageList";
import TBLProdutos from "../../components/TBLProdutos";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { getUser } from "../../services/Auth";
import { toast } from "react-toastify";
import { ImageInfo, Preview } from "./styles";
import AtualizacaoExcel from "./AtualizacaoExcel";
import { ListarCorredores } from "../../providers/CorredoresProvider";
import { BuscarProdutoPorNomeOuSku } from "../../providers/BuscaProvider";

export default class Produtos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      produtos: [],
      corredorSelecionadoFiltro: null,
      categoriaSelecionadaFiltro: null,
      pages: 1,
      page: 1,
      limit: 10,
      loading: false,
      embalagens: [],
      produtoSelecionado: null,
      corredores: [],
      corredorSelecionado: null,
      embalagemSelecionada: null,
      categoriaSelecionada: null,
      showModalProduto: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarProduto: false,

      erro: {
        SKU: "",
        Nome: "",
        Corredor: "",
        Categoria: "",
        Imagem: "",
        Quantidade: "",
        Preco: "",
        Peso: "",
        Embalagem: "",
        Codigo_interno: "",
        Fornecedor: "",
      },

      produtoSKU: "",
      produtoCodigo_interno: "",
      produtoFornecedor: "",
      produtoId: "",
      produtoNome: "",
      produtoCorredor: null,
      produtoCategoria: null,
      produtoImagem: null,
      produtoQuantidade: "",
      produtoDescricao: "",
      produtoPreco: {
        preco_original: "",
        preco_encarte: "",
      },
      produtoPeso: "",
      produtoEmbalagem: "",

      mensagemAlert: "",
      variantAlert: "",
      carregarDadosTabela: true,
      uploadedImages: [],
    };
    this.fileInput = null;
  }

  handleCloseModalProduto = () => {
    this.setState({ showModalProduto: false });
    this.limparForm();
  };

  handleShowModalProduto = () => {
    this.setState({ showModalProduto: true });
  };

  handleShowAlert = (mensagem, variant) => {
    if (variant === "success") {
      toast.success(mensagem);
    } else {
      toast.error(mensagem);
    }
  };

  handleCloseModalAlert = () => {
    this.setState({ showModalAlert: false });
    this.limparForm();
  };

  handleShowModalAlert = () => {
    this.setState({ showModalAlert: true });
  };

  fileChangedHandler = (event) => {
    if (event.target.files[0].size > 490000) {
      alert("Imagem muito grande, selecione uma imagem de tamanho menor!");
      event.target.value = null;
      return;
    } else {
      this.setState({ produtoImagem: event.target.files[0] });
    }
  };

  alterarValorCorredor = (opcao) => {
    this.setState({ corredorSelecionado: opcao, produtoCorredor: opcao.value });
  };

  alterarValorEmbalagem = (opcao) => {
    this.setState({
      embalagemSelecionada: opcao,
      produtoEmbalagem: opcao.value,
    });
  };

  alterarValorCategoria = (opcao) => {
    this.setState({
      categoriaSelecionada: opcao,
      produtoCategoria: opcao.value,
    });
  };

  handleVerifyError = () => {
    const form = this.state;
    let flag = true;
    let erroMensage = {};

    Object.keys(form).forEach((campo) => {
      if (
        campo.startsWith("produto") &&
        !campo.includes("produtos") &&
        !campo.includes("produtoId") &&
        !campo.includes("produtoImagem") &&
        !campo.includes("produtoSelecionado")
      ) {
        if (!form[campo] && campo !== "produtoDescricao") {
          flag = false;
          erroMensage = {
            ...erroMensage,
            [campo.replace("produto", "")]: `Por favor, preencha o ${campo.replace(
              "produto",
              "",
            )} do produto`,
          };
        }
      }
    });

    this.setState({ erro: erroMensage });
    return flag;
  };

  getProdutos = async (current_page) => {
    this.setState({ loading: true });
    const { docs, page, pages } = await listarProdutos(current_page || 1);
    if (docs) {
      this.setState({
        produtos: docs,
        pages,
        page,
        loading: false,
        limit: 10,
      });
    }
  };

  cadastrarProduto = async () => {
    let form = new FormData();
    const usuario = await getUser();
    if (this.handleVerifyError()) {
      form.append("sku", this.state.produtoSKU);
      form.append("codigo_interno", this.state.produtoCodigo_interno);
      form.append("nome", this.state.produtoNome);
      form.append("peso", this.state.produtoPeso);
      form.append("descricao", this.state.produtoDescricao);
      form.append("fabricante[nome]", this.state.produtoFornecedor);
      form.append("quantidade", this.state.produtoQuantidade);
      form.append("preco[preco_original]", this.state.produtoPreco.preco_original);
      if (this.state.produtoPreco.preco_encarte) {
        form.append("preco[preco_encarte]", this.state.produtoPreco.preco_encarte);
      }
      if (usuario) {
        form.append("estabelecimento", usuario.estabelecimento._id);
      } else {
        this.setState({
          errorCadastro: "Vocè não possui sessão ativa, por favor relogue.",
        });
        return;
      }
      form.append("corredor", this.state.corredorSelecionado.value);
      form.append("categoria", this.state.categoriaSelecionada.value);
      form.append("tipo_embalagem", this.state.embalagemSelecionada.value);
      if (this.state.uploadedImages.length > 0) {
        this.state.uploadedImages.forEach((image) => {
          form.append("imagem", image.image);
        });
      }
      try {
        const response = await CadastrarProduto(form);

        if (response) {
          await this.getProdutos(this.state.page);
          this.limparForm();
          this.handleShowAlert("Produto cadastrado com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert("Erro ao cadastrar produto", "danger");
      }
    }
  };

  editarProduto = async (produto) => {
    let form = new FormData();
    if (this.handleVerifyError()) {
      form.append("sku", this.state.produtoSKU);
      form.append("codigo_interno", this.state.produtoCodigo_interno);
      form.append("nome", this.state.produtoNome);
      form.append("descricao", this.state.produtoDescricao);
      form.append("fabricante[nome]", this.state.produtoFornecedor);
      form.append("quantidade", this.state.produtoQuantidade);
      form.append("peso", this.state.produtoPeso);
      form.append("tipo_embalagem", this.state.embalagemSelecionada.value);
      form.append("preco[preco_original]", this.state.produtoPreco.preco_original);

      if (this.state.produtoPreco.preco_encarte) {
        form.append("preco[preco_encarte]", this.state.produtoPreco.preco_encarte);
      }
      if (this.state.corredorSelecionado !== null) {
        form.append("corredor", this.state.corredorSelecionado.value);
      }
      if (this.state.categoriaSelecionada !== null) {
        form.append("categoria", this.state.categoriaSelecionada.value);
      }
      if (this.state.uploadedImages.length !== 0) {
        this.state.uploadedImages.forEach((image) => {
          form.append("imagem", image.image);
        });
      } else {
        form.append("imagem", "");
      }
      try {
        const response = await EditarProduto(form, produto._id);
        if (response) {
          if (this.state.categoriaSelecionadaFiltro) {
            await this.listarProdutosPorcategoria(this.state.page);
          } else {
            await this.getProdutos(this.state.page);
          }
          this.limparForm();
          this.handleShowAlert("Produto editado com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert("Erro ao editar produto", "danger");
      }
    }
  };

  deletarProduto = async (produto) => {
    try {
      const response = await DeletarProduto(produto._id);
      if (response) {
        await this.getProdutos(this.state.page);
        this.limparForm();
        this.handleShowAlert("Produto deletado com sucesso", "success");
      }
    } catch (error) {
      this.handleShowAlert("Erro ao deletar produto", "danger");
    }
  };

  async componentDidMount() {
    await this.getProdutos();
    this.setState({
      embalagens: [
        { value: "kg", label: "Kg" },
        { value: "und", label: "Unidade" },
      ],
    });

    const corredores = await ListarCorredores();
    corredores.forEach((item) => {
      item.label = item.nome;
      item.value = item._id;

      item.categorias.forEach((c) => {
        c.label = c.nome;
        c.value = c._id;
      });
    });
    this.setState({ corredores: corredores });
  }

  limparForm = () => {
    this.setState({
      produtoSelecionado: null,
      corredorSelecionado: null,
      embalagemSelecionada: null,
      categoriaSelecionada: null,
      showModalProduto: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarProduto: false,

      erro: {
        SKU: "",
        Nome: "",
        Corredor: "",
        Categoria: "",
        Imagem: "",
        Quantidade: "",
        Preco: "",
        Peso: "",
        Fornecedor: "",
        Codigo_interno: "",
      },

      produtoSKU: "",
      produtoCodigo_interno: "",
      produtoNome: "",
      produtoPeso: "",
      produtoCorredor: null,
      produtoCategoria: null,
      produtoImagem: null,
      produtoQuantidade: "",
      produtoDescricao: "",
      produtoFornecedor: "",
      produtoPreco: {
        preco_original: "",
        preco_encarte: "",
      },
      uploadedImages: [],
    });
    this.fileInput ? (this.fileInput.value = "") : (this.fileInput = null);
  };

  preencherFormEdit = (dados) => {
    const embalagens = {
      value: dados.tipo_embalagem,
      label: dados.tipo_embalagem,
    };
    const { fotos_produto } = dados;
    let newUploadedImages = null;
    newUploadedImages = fotos_produto?.map((image) => ({
      image,
      preview: api_url_produtos_image + image,
    }));

    this.setState({
      corredorSelecionado: {
        label: dados.categoria.corredor.nome,
        value: dados.categoria.corredor._id,
      },
      categoriaSelecionada: {
        label: dados.categoria.nome,
        value: dados.categoria._id,
      },
      produtoCorredor: dados.categoria.corredor._id,
      produtoCategoria: dados.categoria._id,
      produtoSelecionado: dados,
      produtoId: dados._id,
      produtoNome: dados.nome,
      produtoPeso: dados.peso,
      produtoDescricao: dados.descricao,
      produtoFornecedor: dados.fabricante ? dados.fabricante.nome : "",
      produtoQuantidade: dados.quantidade,
      produtoSKU: dados.sku,
      produtoCodigo_interno: dados.codigo_interno,
      produtoEmbalagem: dados.tipo_embalagem,
      produtoPreco: {
        preco_original: dados.preco.preco_original,
        preco_encarte: dados.preco.preco_encarte ? dados.preco.preco_encarte : "",
      },
      embalagemSelecionada: {
        label: embalagens.label === "kg" ? "Kg" : "Unidade",
        value: embalagens.value,
      },
      produtoImagem: dados.foto_produto,
      uploadedImages: newUploadedImages || [],
      modoEditarProduto: true,
    });
    this.handleShowModalProduto();
  };

  receberDadosTabela = (tipo, dados) => {
    if (tipo === "editar") {
      this.preencherFormEdit(dados);
    } else if (tipo === "deletar") {
      this.setState({ produtoSelecionado: dados });
      this.handleShowModalAlert();
    } else {
      return;
    }
  };

  listProdutos = async (page) => {
    const { docs } = await listarProdutos(page);
    this.setState({ produtos: docs });
  };

  listarProdutosPorcategoria = async (current_page) => {
    const { docs, limit, page, pages } = await listarProdutosPorCategoria(
      this.state.categoriaSelecionadaFiltro.value,
      current_page,
    );
    this.setState({
      produtos: docs,
      limit,
      page,
      pages,
    });
  };

  buscarProdutos = async (busca) => {
    if (busca) {
      const response = await BuscarProdutoPorNomeOuSku(busca);
      this.setState({ produtos: response, carregarDadosTabela: false });
    } else {
      this.listProdutos();
      this.setState({ carregarDadosTabela: true });
    }
  };

  handleUploadImages = (images) => {
    const { uploadedImages } = this.state;
    if (uploadedImages.length < 3) {
      images.forEach((image) => {
        const newImage = {
          image,
          preview: URL.createObjectURL(image),
        };
        if (uploadedImages.length < 3) {
          uploadedImages.push(newImage);
        }
      });
      this.setState({
        uploadedImages,
      });
    } else {
      return false;
    }
  };

  handleDeleteImage = async (index) => {
    const { uploadedImages, produtoSelecionado } = this.state;
    let newUploadedImages = null;
    uploadedImages.forEach(async (image, imageIndex) => {
      if (imageIndex === index) {
        if (typeof image.image !== "string") {
          newUploadedImages = uploadedImages.filter(
            (image, imageIndex) => imageIndex !== index,
          );
          this.setState({ uploadedImages: newUploadedImages });
        } else {
          newUploadedImages = uploadedImages.filter(
            (image, imageIndex) => imageIndex !== index,
          );
          const fotos = {
            fotos_produto: [],
          };
          newUploadedImages.forEach((image) => {
            fotos.fotos_produto.push(image.image);
          });
          try {
            const response = await EditarProduto(fotos, produtoSelecionado._id);
            if (response) {
              if (this.state.categoriaSelecionadaFiltro) {
                await this.listarProdutosPorcategoria(this.state.page);
              } else {
                await this.getProdutos(this.state.page);
              }
            }
            this.setState({ uploadedImages: newUploadedImages });
          } catch (error) {
            this.handleShowAlert("Erro ao excluir foto!", "danger");
          }
        }
      }
    });
  };

  render() {
    const {
      uploadedImages,
      produtoSelecionado,
      showAlert,
      variantAlert,
      mensagemAlert,
      corredorSelecionadoFiltro,
      corredores,
      categoriaSelecionadaFiltro,
      produtos,
      limit,
      pages,
      loading,
      showModalProduto,
      errorCadastro,
      modoEditarProduto,
      produtoId,
      corredorSelecionado,
      erro,
      categoriaSelecionada,
      produtoSKU,
      produtoCodigo_interno,
      produtoNome,
      produtoDescricao,
      produtoFornecedor,
      produtoQuantidade,
      produtoPeso,
      produtoPreco,
      embalagemSelecionada,
      embalagens,
      showModalAlert,
    } = this.state;
    const productImageSrc = uploadedImages.length
      ? uploadedImages[0].preview
      : api_url_produtos_image +
          String(produtoSelecionado?.foto_produto).replace(/ /gi, "%20") ||
        String(produtoSelecionado?.fotos_produto[0]).replace(/ /gi, "%20");
    return (
      <div>
        {showAlert ? (
          <Alert style={{ zIndex: 99999999999 }} variant={variantAlert}>
            {mensagemAlert}
          </Alert>
        ) : null}
        <br></br>
        <Row>
          <Col md={9}>
            <h3>Produtos</h3>
          </Col>
          <Col>
            <Button
              onClick={() => {
                this.handleShowModalProduto();
              }}
            >
              Cadastrar produto
            </Button>
          </Col>
          <Col>
            <AtualizacaoExcel />
          </Col>
        </Row>
        <h4>Filtros</h4>
        <Row>
          <Col>
            <Form.Label>Corredor</Form.Label>
            <Select
              value={corredorSelecionadoFiltro}
              options={corredores}
              onChange={(e) => this.setState({ corredorSelecionadoFiltro: e })}
              isClearable={false}
              placeholder="Corredor"
            ></Select>
          </Col>
          <Col>
            <Form.Label>Categoria</Form.Label>
            <Select
              value={categoriaSelecionadaFiltro}
              isDisabled={!corredorSelecionadoFiltro}
              options={
                corredorSelecionadoFiltro ? corredorSelecionadoFiltro.categorias : []
              }
              onChange={(e) => this.setState({ categoriaSelecionadaFiltro: e })}
              isClearable={false}
              placeholder="Categoria"
            ></Select>
          </Col>
          <Col>
            <Form.Label>Ações</Form.Label>
            <div>
              <Button
                variant="danger"
                style={{ marginRight: 10 }}
                disabled={!categoriaSelecionadaFiltro}
                onClick={() => {
                  this.setState({
                    categoriaSelecionadaFiltro: null,
                    corredorSelecionadoFiltro: null,
                    page: 1,
                  });
                  this.getProdutos(1);
                }}
              >
                Limpar
              </Button>
              <Button
                variant="primary"
                disabled={!categoriaSelecionadaFiltro}
                onClick={() => this.listarProdutosPorcategoria()}
              >
                Aplicar
              </Button>
            </div>
          </Col>
        </Row>
        <br></br>
        <div>
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
              </InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl
              placeholder="Pesquisar produtos por código"
              onChange={(e) => this.buscarProdutos(e.target.value)}
            />
          </InputGroup>
          <TBLProdutos
            data={produtos}
            dataCallback={this.receberDadosTabela}
            getProdutos={() => this.getProdutos()}
            limit={limit}
            pages={pages}
            loading={loading}
            changePage={(p) =>
              categoriaSelecionadaFiltro
                ? this.listarProdutosPorcategoria(p)
                : this.getProdutos(p)
            }
            showAcoes={true}
          ></TBLProdutos>
        </div>

        <Modal size="xl" show={showModalProduto} onHide={this.handleCloseModalProduto}>
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {modoEditarProduto ? "Editar Produto" : "Cadastrar Produto"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {modoEditarProduto ? (
              <div style={{ width: "100%", textAlign: "center", marginBottom: 20 }}>
                <ImageInfo>
                  <Preview src={productImageSrc} />
                </ImageInfo>
              </div>
            ) : null}
            {errorCadastro ? (
              <div>
                <p style={{ color: "red" }}>{errorCadastro}</p>
              </div>
            ) : null}
            <Form>
              <Form.Group controlId="formProduto">
                <Row>
                  <Col>
                    <Form.Label>ID: {produtoId}</Form.Label>
                  </Col>
                  {this.state.produtoSelecionado ? (
                    <Col>
                      <Form.Label>
                        Atualizado em:{" "}
                        {new Date(this.state.produtoSelecionado.updatedAt).toLocaleString(
                          "pt-BR",
                        )}
                      </Form.Label>
                    </Col>
                  ) : null}
                </Row>
                <Row>
                  <Col>
                    <Form.Label>Corredor *</Form.Label>
                    <Select
                      value={corredorSelecionado}
                      options={corredores}
                      onChange={(e) => this.alterarValorCorredor(e)}
                      isClearable={false}
                      placeholder="Corredor"
                    ></Select>
                    {erro.Corredor ? (
                      <div>
                        <p style={{ color: "red" }}>{erro.Corredor}</p>
                      </div>
                    ) : null}
                  </Col>
                  <Col>
                    <Form.Label>Categoria *</Form.Label>
                    <Select
                      value={categoriaSelecionada}
                      options={
                        corredorSelecionado != null ? corredorSelecionado.categorias : []
                      }
                      onChange={(e) => this.alterarValorCategoria(e)}
                      isClearable={false}
                      placeholder="Categoria"
                    ></Select>
                    {erro.Categoria ? (
                      <div>
                        <p style={{ color: "red" }}>{erro.Categoria}</p>
                      </div>
                    ) : null}
                  </Col>
                </Row>
              </Form.Group>
              <Row>
                <Col>
                  <Form.Group controlId="formProduto">
                    <Form.Label>SKU *</Form.Label>
                    <Form.Control
                      value={produtoSKU}
                      type="text"
                      placeholder="SKU do Produto"
                      onChange={(e) => {
                        this.setState({ produtoSKU: e.target.value });
                      }}
                    />
                    {erro.SKU ? (
                      <div>
                        <p style={{ color: "red" }}>{erro.SKU}</p>
                      </div>
                    ) : null}
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="formProduto">
                    <Form.Label>Código interno *</Form.Label>
                    <Form.Control
                      value={produtoCodigo_interno}
                      type="text"
                      placeholder="Código do Produto"
                      onChange={(e) => {
                        this.setState({
                          produtoCodigo_interno: e.target.value,
                        });
                      }}
                    />
                    {erro.Codigo_interno ? (
                      <div>
                        <p style={{ color: "red" }}>{erro.Codigo_interno}</p>
                      </div>
                    ) : null}
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="formProduto">
                    <Form.Label>Nome *</Form.Label>
                    <Form.Control
                      value={produtoNome}
                      type="text"
                      placeholder="Nome do Produto"
                      onChange={(e) => {
                        this.setState({ produtoNome: e.target.value });
                      }}
                    />
                    {erro.Nome ? (
                      <div>
                        <p style={{ color: "red" }}>{erro.Nome}</p>
                      </div>
                    ) : null}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={8}>
                  <Form.Group controlId="formProduto">
                    <Form.Label>Descrição</Form.Label>
                    <Form.Control
                      value={produtoDescricao}
                      type="text"
                      placeholder="Descrição"
                      onChange={(e) => {
                        this.setState({ produtoDescricao: e.target.value });
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="formProduto">
                    <Form.Label>Fornecedor *</Form.Label>
                    <Form.Control
                      value={produtoFornecedor}
                      type="text"
                      placeholder="Fornecedor"
                      onChange={(e) => {
                        this.setState({ produtoFornecedor: e.target.value });
                      }}
                    />
                    {erro.Fornecedor ? (
                      <div>
                        <p style={{ color: "red" }}>{erro.Fornecedor}</p>
                      </div>
                    ) : null}
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group controlId="formProduto">
                    <Form.Label>Quantidade *</Form.Label>
                    <Form.Control
                      value={produtoQuantidade || ""}
                      type="number"
                      min={1}
                      placeholder="Quantidade"
                      onChange={(e) => {
                        this.setState({ produtoQuantidade: e.target.value });
                      }}
                    />
                    {erro.Quantidade ? (
                      <div>
                        <p style={{ color: "red" }}>{erro.Quantidade}</p>
                      </div>
                    ) : null}
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="formProduto">
                    <Form.Label>Peso em KG *</Form.Label>
                    <Form.Control
                      value={produtoPeso || ""}
                      type="number"
                      min={1}
                      placeholder="Peso"
                      onChange={(e) => {
                        this.setState({ produtoPeso: e.target.value });
                      }}
                    />
                    {erro.Peso ? (
                      <div>
                        <p style={{ color: "red" }}>{erro.Peso}</p>
                      </div>
                    ) : null}
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group controlId="formProduto">
                <Row>
                  <Col>
                    <Form.Label>Preço Original *</Form.Label>
                    <Form.Control
                      value={produtoPreco.preco_original || ""}
                      type="number"
                      min={1}
                      placeholder="R$"
                      onChange={(e) => {
                        this.setState({
                          produtoPreco: {
                            ...produtoPreco,
                            preco_original: e.target.value,
                          },
                        });
                      }}
                    />
                    {erro.Preco ? (
                      <div>
                        <p style={{ color: "red" }}>{erro.Preco}</p>
                      </div>
                    ) : null}
                  </Col>
                  <Col>
                    <Form.Label>Preço com Desconto </Form.Label>
                    <Form.Control
                      value={produtoPreco.preco_encarte || ""}
                      type="number"
                      min={1}
                      placeholder="R$"
                      onChange={(e) => {
                        this.setState({
                          produtoPreco: {
                            ...produtoPreco,
                            preco_encarte: e.target.value,
                          },
                        });
                      }}
                    />
                  </Col>
                  <Col>
                    <Form.Label>Tipo de embalagem *</Form.Label>
                    <Select
                      value={embalagemSelecionada}
                      options={embalagens}
                      onChange={(e) => this.alterarValorEmbalagem(e)}
                      isClearable={false}
                      placeholder="Tipo da embalagem"
                    ></Select>
                    {erro.Embalagem ? (
                      <div>
                        <p style={{ color: "red" }}>{erro.Embalagem}</p>
                      </div>
                    ) : null}
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group controlId="formProduto">
                <Form.Label>Imagem *</Form.Label>
                <UploadImage onUpload={this.handleUploadImages} />
                {!!uploadedImages.length && (
                  <ImageList images={uploadedImages} onDelete={this.handleDeleteImage} />
                )}
                {/* <input className={"form-control"} type="file" accept="image/x-png,image/jpeg"
                                    ref={ref => this.fileInput = ref}
                                    onChange={this.fileChangedHandler}></input> */}
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalProduto();
              }}
            >
              Fechar
            </Button>
            {modoEditarProduto ? (
              <Button
                variant="primary"
                onClick={() => {
                  this.editarProduto(produtoSelecionado);
                }}
              >
                {"Editar"}
              </Button>
            ) : (
              <Button
                variant="primary"
                onClick={() => {
                  this.cadastrarProduto();
                }}
              >
                {"Cadastrar"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <Modal size="sm" show={showModalAlert} onHide={this.handleCloseModalAlert}>
          <Modal.Header closeButton>
            <Modal.Title>Alerta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Deseja realmente excluir o produto?</p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalAlert();
              }}
            >
              Não
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.deletarProduto(produtoSelecionado);
              }}
            >
              Sim
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
